import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';

import ChatMessage from './ChatMessage';

export default class ChatHistory extends Component {

  //props (expected component properties)
  static propTypes = {
	appState: PropTypes.object.isRequired,
	appStateUpdate: PropTypes.func.isRequired,

	messages: PropTypes.array.isRequired,
 };



  constructor(props) {
	 super(props);

	 this.devMode = props.appState.devMode;
	 
	 this.messageRefs = {};

	 this.state = {
		 container: null,
	
	 };

 }


 txt = (text) =>
 {
   //handle text translations from config
   const { props } = this;
   if (!props.appState.config) return text;
   if (text in props.appState.config.text) return props.appState.config.text[text];

   return text;
 }
 
  onScroll = () => {
 
	const { refs } = this;
	const scrollTop = refs.messageList.scrollTop;
   
	if (scrollTop === 0) {
	}

  };

  scrollToBottom = () => {
	const { messageList } = this.refs;
	const scrollHeight = messageList.scrollHeight;
	const height = messageList.clientHeight;
	const maxScrollTop = scrollHeight - height;
	ReactDOM.findDOMNode(messageList).scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
	
	console.log('components/ChatHistory scrollToBottom', maxScrollTop, scrollHeight, height);
  }

  messageClick = (e, messageID, userName) =>
  {
	e.stopPropagation();

	const { props } = this;

	 if(this.devMode) console.log('components/ChatHistory messageClick',messageID, userName, this.devMode, e, props.messages.find(x => x.ID === messageID) );

    if (props.appState.chatMentionMessage != messageID || props.appState.chatMentionUser != userName) 
    props.appStateUpdate({chatMentionMessage: messageID, chatMentionUser: userName});
  }

  messageScroll = (e, messageID) =>
  {
	if(this.devMode) console.log('components/ChatHistory messageScroll', messageID, this.messageRefs[messageID]);
	e.stopPropagation();
	
	if (this.messageRefs) if (this.messageRefs[messageID]) if (this.messageRefs[messageID].current)
	this.messageRefs[messageID].current.scrollIntoView({
	  behavior: 'smooth',
	  block: 'start',
	});

  }

  componentDidMount() {
   if(this.devMode)  console.log('components/ChatHistory componentDidMount', this.props);
  }

  componentDidUpdate() {
//	this.scrollToBottom();
  }
  
  render() {
	const { props, state, onScroll } = this;

	this.devMode = props.appState.devMode;


  var modeText = false;
  if (!props.appState.checked || (props.appState.checked && props.appState.mode.text)) modeText = true;

	let messageList; 
	var previousUser = '';
	var previousTime = 0;
	var previousID = 0;

	this.messageRefs = {};
	this.mIDs = [];

	if (props.messages.length>0)
	 messageList = (<ul className="chatMessageList" ref="messageList" key="messageList" onScroll={onScroll}>
	  {props.messages.map( (messageObj) => {

		  if (modeText) if (messageObj.modeText) 
		  {
			messageObj.text = props.appState.tooltip;
			messageObj.url = props.appState.tooltipURL;
			messageObj.image = props.appState.tooltipImage;
		  }

		  if (!this.messageRefs[messageObj.ID]) this.messageRefs[messageObj.ID] = React.createRef();
		
		  const output = <ChatMessage txt={this.txt} messageRef={this.messageRefs[messageObj.ID]} messageClick={this.messageClick} messageScroll={this.messageScroll} darkMode={props.appState.darkMode} contactID={props.appState.contact.id} message={messageObj} key={messageObj.ID} previousUser={previousUser} previousTime={previousTime} appState={props.appState} appStateUpdate={props.appStateUpdate} />

		  previousUser = messageObj.userName + '#' + messageObj.userID;
		  previousTime = messageObj.time;

		  //skip modeText if not active
		  if (messageObj.modeText) if (!modeText) return '';
		  
		  //skip duplicate
		  if (previousID === messageObj.ID) return '';  //previous
		  if  (this.mIDs.indexOf(messageObj.ID) >= 0) return ''; //already show
		  previousID = messageObj.ID;

		  //output
		 this.mIDs.push(previousID); //remember displayed
		 return output;

	  })
	  }
	</ul>);
	else messageList = (
<ul className="chatMessageList" key="messageList" ref="messageList" onScroll={onScroll}>
  <li className="chatMessage" key="0">  
	  <span>No Messages.</span>
  </li>
</ul>);



	return (
	  <div className="messageListContainer"> 
			{messageList}
	  </div>
	);
  }

}